<template>
  <span
    class="status-pill"
    :class="`status-pill--${color}`">
    <slot>{{ label }}</slot>
  </span>
</template>

<script setup lang="ts">
interface Props {
  color: string
  label?: string
}

defineProps<Props>()
</script>

<style lang="scss" scoped>
.status-pill {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 0.7rem;
  font-weight: 600;
  letter-spacing: 0.02em;
  line-height: 1.4;
  white-space: nowrap;
  border: 1px solid transparent;
  transition: background-color 0.15s ease;
}

@mixin chip-colors($color) {
  background: color-mix(in srgb, $color 14%, transparent);
  color: color-mix(in srgb, $color 40%, #000);
  border-color: color-mix(in srgb, $color 25%, transparent);
}

@mixin chip-colors-dark($color) {
  background: color-mix(in srgb, $color 22%, transparent);
  color: color-mix(in srgb, $color 30%, #fff);
  border-color: color-mix(in srgb, $color 35%, transparent);
}

.status-pill--primary { @include chip-colors(var(--q-primary)); }
.status-pill--secondary { @include chip-colors(var(--q-secondary)); }
.status-pill--accent { @include chip-colors(var(--q-accent)); }
.status-pill--positive { @include chip-colors(var(--q-positive)); }
.status-pill--negative { @include chip-colors(var(--q-negative)); }
.status-pill--warning { @include chip-colors(var(--q-warning)); }
.status-pill--info { @include chip-colors(var(--q-info)); }
.status-pill--orange { @include chip-colors(#f39c12); }
.status-pill--purple { @include chip-colors(#9c27b0); }
.status-pill--teal { @include chip-colors(#009688); }
.status-pill--muted { @include chip-colors(#9e9e9e); }
.status-pill--default { @include chip-colors(#6b7280); }
.status-pill--grey { @include chip-colors(#888); }

.body--dark {
  .status-pill--primary { @include chip-colors-dark(var(--q-primary)); }
  .status-pill--secondary { @include chip-colors-dark(var(--q-secondary)); }
  .status-pill--accent { @include chip-colors-dark(var(--q-accent)); }
  .status-pill--positive { @include chip-colors-dark(var(--q-positive)); }
  .status-pill--negative { @include chip-colors-dark(var(--q-negative)); }
  .status-pill--warning { @include chip-colors-dark(var(--q-warning)); }
  .status-pill--info { @include chip-colors-dark(var(--q-info)); }
  .status-pill--orange { @include chip-colors-dark(#f39c12); }
  .status-pill--purple { @include chip-colors-dark(#9c27b0); }
  .status-pill--teal { @include chip-colors-dark(#009688); }
  .status-pill--muted { @include chip-colors-dark(#9e9e9e); }
  .status-pill--default { @include chip-colors-dark(#9aa0a6); }
  .status-pill--grey { @include chip-colors-dark(#aaa); }
}
</style>

